import { useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import axios from 'axios';

const AuthContainer = () => {

    const { state } = useLocation();
    const token = state && state.token;


    const [selectedTable, setSelectedTable] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [updateData, setUpdateData] = useState('');

    const handleTableClick = async (tableName) => {
        try {
            const response = await axios.get(`/api/${tableName}`); // Replace '/api/:tableName' with your API endpoint for fetching table data
            setTableData(response.data);
            setSelectedTable(tableName);
        } catch (error) {
            console.error('Error fetching table data:', error);
        }
    };

    const handleUpdate = async () => {
        try {
            // Example: Update data for the selected table
            await axios.put(`/api/${selectedTable}`, { data: updateData }); // Replace '/api/:tableName' with your API endpoint for updating table data
            // Optionally, you can refresh the table data after updating
            handleTableClick(selectedTable);
        } catch (error) {
            console.error('Error updating table data:', error);
        }
    };

    return (
        <div>
            <div className="menu">
                <ul>
                    <li onClick={() => handleTableClick('coupons')}>Coupons</li>
                    <li onClick={() => handleTableClick('playdetails')}>Play Details</li>
                    <li onClick={() => handleTableClick('team_game')}>Team Game</li>
                </ul>
            </div>
            <div className="table-container">
                {selectedTable && (
                    <div>
                        <h2>{selectedTable.toUpperCase()}</h2>
                        <table>
                            <thead>
                                {/* Add table header based on the selected table */}
                                <tr>
                                    <th>ID</th>
                                    <th>{/* Add table column headers */}</th>
                                    {/* Add other table column headers */}
                                </tr>
                            </thead>
                            <tbody>
                                {/* Render table data based on the selected table */}
                                {tableData.map((row) => (
                                    <tr key={row.id}>
                                        <td>{row.id}</td>
                                        <td>{/* Add table data cells */}</td>
                                        {/* Add other table data cells */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <button onClick={handleUpdate}>Update</button>
                        <input
                            type="text"
                            value={updateData}
                            onChange={(e) => setUpdateData(e.target.value)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default AuthContainer;